import React, {useState} from 'react';
import classes from './Collapsible.module.css';

const Collapsible = ({children, label}) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={classes.container}>
            <button className={classes.toggleAndLabel} onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} aria-controls="collapsible">
                <span>{label}</span>
                <span className={isOpen ? `${classes.toggleEmblem} ${classes.open}` : classes.toggleEmblem}>⯈</span>
            </button>
            <div id="collapsible" className={isOpen ? `${classes.content} ${classes.show}` : classes.content}>{children}</div>
        </div>
    );
};

export default Collapsible;
